/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { IFormRadioOption } from '../_shared/models/form/form-radio.model';
import { LabelComponent } from '../label/label.component';

@Component({
    selector: 'sirius-radio',
    templateUrl: './radio.component.html',
    styleUrls: ['./radio.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LabelComponent, CommonModule]
})
export class RadioComponent implements OnInit, ControlValueAccessor {
    private _ngControl = inject(NgControl, { self: true });

    @Input() label = '';
    @Input() options: IFormRadioOption[] = [];
    @Input() name = '';
    @Input() identifier = '';

    ids: string[] = [];

    private _valid = new BehaviorSubject<boolean>(true);
    valid$ = this._valid.asObservable();

    get control() {
        return this._ngControl.control as FormControl;
    }

    onChange = (value: string) => {
        //empty
    };

    onTouched = () => {
        //empty
    };

    constructor() {
        const _ngControl = this._ngControl;

        _ngControl.valueAccessor = this;
    }

    ngOnInit(): void {
        this.options.forEach(() => this.ids.push(uuidv4()));

        this.control.statusChanges.subscribe((status) => {
            this._valid.next(status !== 'INVALID' ? true : false);
        });
    }

    // ControlValueAccessor
    writeValue = (value: string) => undefined;

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        if (isDisabled) this.control?.disable();
    }
}
